import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../services/api";
import {
  setAllCohorts,
  setMenuCohorts
} from "../features/cohort/cohortSlice";

export default function useCohortBootstrap() {
  const dispatch = useDispatch();
  const role = useSelector(state => state.auth.role);

  useEffect(() => {
    if (!role) return;

    const fetchCohorts = async () => {
      try {
        const res = await api.get(
          "https://aidemo.fusionsystemsinc.com/api/v1/business/cohorts",
          { headers: { accept: "application/json" } }
        );

        const items = res.data.items || [];

        // 1️⃣ SET ALL (ADMIN + BUSINESS)
        dispatch(setAllCohorts(items));

        // 2️⃣ BUSINESS MENU ONLY (EARLIEST PER TRACE)
        if (role === "business") {
          const grouped = {};
          items.forEach(item => {
            if (
              !grouped[item.trace_id] ||
              new Date(item.created_at) <
                new Date(grouped[item.trace_id].created_at)
            ) {
              grouped[item.trace_id] = item;
            }
          });

          dispatch(setMenuCohorts(Object.values(grouped)));
        }

      } catch (err) {
        console.error("Cohort bootstrap failed", err);
      }
    };

    fetchCohorts();
  }, [role, dispatch]);
}
